import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { ExpandMore, CalendarMonth } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '../SidebarAccordion.component';
import { observer } from 'mobx-react-lite';
import { CalendarDateService } from '@uplift/services';
import { CreateOutOfOfficeModal } from '../OutOfOfficeModal/CreateOutOfOfficeModal.component';
import { UpdateOutOfOfficeModal, OOOInitialValues } from '../OutOfOfficeModal/UpdateOutOfOfficeModal.component';
import { OutOfOfficeEventRow } from './OutOfOfficeEventRow.component';
import { useCurrentuser } from '@uplift/contexts';
import { useProviderOutOfOfficeQuery, useDeleteProviderOutOfOfficeMutation } from '@uplift/queries';

export const SidebarOutOfOffice: React.FC = observer(() => {
  const me = useCurrentuser();
  const { data: oooEvents = [] } = useProviderOutOfOfficeQuery(me.id);
  const deleteOutOfOfficeMutation = useDeleteProviderOutOfOfficeMutation();
  const [ oooModalOpen, setOooModalOpen ] = React.useState(false);
  const [ editOOOModalOpen, setEditOOOModalOpen ] = React.useState(false);
  const [ editingEvent, setEditingEvent ] = React.useState<OOOInitialValues | undefined>(undefined);

  const handleEditEvent = (event: OOOInitialValues) => {
    setEditingEvent(event);
    setEditOOOModalOpen(true);
  };

  const handleModalClose = () => {
    setOooModalOpen(false);
    setEditingEvent(undefined);
  };

  const handleEditModalClose = () => {
    setEditOOOModalOpen(false);
    setEditingEvent(undefined);
  };

  const handleDelete = (_id: string) => {
    deleteOutOfOfficeMutation.mutate({ providerId: me.id, outOfOfficeId: _id });
  };



  const upComingOutOfOfficeEvents = oooEvents
    .filter((event) => CalendarDateService.date(event.endDate).isSameOrAfter(CalendarDateService.date(), 'day'))
    .map((event) => ({
      id: event.id,
      title: event.eventTitle,
      startDate: CalendarDateService.date(event.startDate),
      endDate: CalendarDateService.date(event.endDate),
    }));

  return (
    <>
      <Typography style={{ fontWeight: 600, padding: '16px 0 8px' }}>Out of Office</Typography>
      <Button color="primary" variant="outlined" fullWidth onClick={() => setOooModalOpen(true)}>
        + Add out of office
      </Button>
      <Accordion elevation={0} >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography style={{ fontWeight: 600 }}>Upcoming Out of Office</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {upComingOutOfOfficeEvents.length > 0 ? upComingOutOfOfficeEvents.map((event) => (
            <OutOfOfficeEventRow
              key={event.id}
              event={event}
              onEdit={handleEditEvent}
              onDelete={() => handleDelete(event.id)}
            />
          )) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2 }}>
              <CalendarMonth color="disabled" />
              <Typography color="textSecondary">
                No upcoming out of office periods
              </Typography>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
      <CreateOutOfOfficeModal
        open={oooModalOpen}
        onClose={handleModalClose}
        providerId={me.id}
        existingEvents={upComingOutOfOfficeEvents}
      />
      <UpdateOutOfOfficeModal
        open={editOOOModalOpen}
        onClose={handleEditModalClose}
        providerId={me.id}
        initialValues={editingEvent}
        existingEvents={upComingOutOfOfficeEvents}
      />
    </>
  );
});
